import useAsync from 'Hooks/useAsync';
import { getFerryBookingTransactionIdFromStorage } from 'Services/Api/_HumanWritten/BookingService/BookingService';
import { fetchBookingsForCart } from 'Services/Api/_HumanWritten/BookingService/FerryTripBookingService';
import { SelectedTrips } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardWrap';
import { useBookingWizardDataStore } from '../BookingWizardDataStore';
import TripBookingSummaryInner from '../WizardSteps/Cart/TripBookingSummaryInner';
import { appConfigStore } from 'Models/AppConfigStore';

export interface TripSummaryProps {
	selectedTrips: SelectedTrips;
	refresh?: () => void;
}

export function TripSummary({ selectedTrips, refresh }: TripSummaryProps) {
	const transactionId = getFerryBookingTransactionIdFromStorage();

	const { wizardData, setWizardData, clearOldWizardData } = useBookingWizardDataStore();

	const response = useAsync(
		() => fetchBookingsForCart(transactionId),
		[wizardData.departureTicketId, wizardData.returningTicketId],
	);

	if (response.type === 'loading' || response.type === 'error') {
		return <></>;
	}

	const bookingList = response.data;

	return (
		<div className="trip-summary-container">
			<h4
				className={
					appConfigStore.passengerClassesEnabled && wizardData.tabSelected !== 'freight'
						? 'class-booking-summary__sidebar-heading'
						: 'mb-4'
				}
			>
				Bookings
			</h4>
			<TripBookingSummaryInner
				bookings={bookingList}
				selectedTrips={selectedTrips}
				refresh={undefined}
				onUpdateWizardData={setWizardData}
				wizardData={wizardData}
				tripSummaryLocation="sidebar"
			/>
		</div>
	);
}
